import { config } from "@/lib/config";
import { Copyright } from "@/components/common/Copyright.tsx";

export const Footer = () => {
  return (
    <footer className="text-xs flex flex-row justify-between px-2 bg-secondary text-secondary-foreground p-2">
      <div>
        <Copyright />
      </div>
      <div className="flex-grow"></div>
      <div>
        <p>
          <span>{`v${config.version}-${config.commitHash}`}</span>
        </p>
      </div>
    </footer>
  );
};
